// extracted by mini-css-extract-plugin
module.exports = {"emailTabMinimized":"az_aLb","emailTabMinimizedContent":"az_bLb","promoToggle":"az_cLb","promoText":"az_dLb","chevronIcon":"az_eLb","rotateToggle":"az_fLb"};